import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import { useContracts } from "@/hooks/useContracts";
import ContractsTable from "./ContractsTable";
import ContractFormModal from "./ContractFormModal";
import { PropertyContract } from "@/hooks/useContracts";
import AdminPageHeader from '@/components/v2/atoms/admin/layout/AdminPageHeader';

const ContractsTab = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingContract, setEditingContract] = useState<PropertyContract | null>(null);
  const { data: contracts, isLoading } = useContracts();

  const handleEdit = (contract: PropertyContract) => {
    setEditingContract(contract);
    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
    setEditingContract(null);
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div className="space-y-2">
          <h2 className="text-2xl font-bold">Contratos</h2>
          <p className="text-muted-foreground">
            Gestiona los contratos de administración de propiedades
          </p>
        </div>
        <Button onClick={() => setIsModalOpen(true)}>
          <Plus className="mr-2 h-4 w-4" />
          Nuevo Contrato
        </Button>
      </div>

      <ContractsTable 
        contracts={contracts || []} 
        isLoading={isLoading} 
        onEdit={handleEdit}
      />

      <ContractFormModal
        isOpen={isModalOpen}
        onClose={handleModalClose}
        contract={editingContract}
      />
    </div>
  );
};

export default ContractsTab;